import { HttpParams, HttpResourceRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { endpoints } from '../../../../../environments/endpoints';
import { DemandsDateRangeChange } from '../../../Catalog/Interfaces/demands-filter-panel.interface';
import { ApiService } from '../../../Shared/Services/api.service';
import { DownloadedFile } from '../../Demand/Interfaces/demand-export.interface';
import { parseContentDispositionFilename } from '../../Demand/Shared/report-file.util';
import { MonitoringResponse } from '../Types/monitoring-response.type';

@Injectable({ providedIn: 'root' })
export class MonitoringService {
  private readonly _api = inject(ApiService);

  show(range: DemandsDateRangeChange, skipLoading: boolean = true): HttpResourceRequest {
    return this._api.get<MonitoringResponse>(endpoints.api.reports.monitoring, {
      params: this._rangeParams(range),
      skipLoading,
    });
  }

  exportWorkbook(range: DemandsDateRangeChange): Observable<DownloadedFile> {
    const request = this._api.get<Blob>(endpoints.api.reports.monitoringExport, {
      params: this._rangeParams(range),
      skipLoading: true,
      skipError: true,
    });

    return this._api.runBlob(request).pipe(
      map((response) => ({
        blob: response.body as Blob,
        filename: parseContentDispositionFilename(response.headers.get('Content-Disposition')),
      })),
    );
  }

  private _rangeParams(range: DemandsDateRangeChange): HttpParams {
    let params = new HttpParams();
    if (range.from) params = params.set('from', range.from);
    if (range.to) params = params.set('to', range.to);
    return params;
  }
}
